import { Link } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import format from 'date-fns/format';
import PtBr from 'date-fns/locale/pt-BR';
import React from 'react';
import { Optional } from 'src/app/shared/utils';
import { Pergunta } from 'src/app/types/votacao';
import styled from 'styled-components';

const Title = styled(Typography)`
  font-weight: bold;
  text-align: start;
`;

const Text = styled(Typography)`
  text-align: start;
`;

const DateText = styled(Typography)`
  color: #707070;
  text-align: center;
  margin-top: 0.3rem;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const StyledAccordion = styled(Accordion) <{ expanded: boolean }>`
  width: 100%;
  padding: 1rem;
  border-bottom: 1px solid #F1F1F3;
  box-shadow: none;

  ${({ expanded }) => expanded && `
    // background-color: #F9F9F9;
    border: 1px solid #DDDDDD;
    border-top: 1px solid #FECC69;
    border-bottom: 1px solid #3B86FF;
  `}

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 1rem 0.5rem;
  }
`;

const corSituacao = {
  1: { backgroundColor: '#FFCA28', color: '#D4612E' },
  3: { backgroundColor: '#43A047', color: '#FFFFFF' },
  4: { backgroundColor: '#D32F2F', color: '#FFFFFF' },
  5: { backgroundColor: '#D32F2F', color: '#FFFFFF' }
}

interface Props {
  item: Pergunta;
  onSelect: (item: Pergunta | undefined) => void;
  selected: boolean;
  children: any;
}

export default ({ item, selected, onSelect, children }: Props) => (
  <StyledAccordion
    expanded={selected}
    onChange={() => selected ? onSelect(undefined) : onSelect(item)}
  >
    <AccordionSummary>
      <Row>
        <Column style={{ flex: 4, marginRight: '0.5rem' }}>
          <Title style={{whiteSpace: 'pre-line'}}>{item.ordem + ' - ' + item.textoPergunta}</Title>
          <Text variant="caption" style={{ color: item.votoUsuario ? '#5587FC' : '#9F9D9D' }}>
            {item.votoUsuario ? `Seu voto: ${item.votoUsuario}` : 'Você não votou'}
          </Text>
          {
            !selected ?
              (<div style={{marginLeft: '60%'}}>
                <p style={{color: '#5d5d5d'}}>
                  <ExpandMoreIcon style={{border: '2px solid #5d5d5d', borderRadius:'14px'}}/>
                </p>
              </div>) : null
          }
          <Optional valid={!!item.opcaoMaisVotada}>
            <Text variant="caption" style={{ color: '#3265dc' }}>
              {item.opcaoMaisVotada}
            </Text>
          </Optional>
          {item.urlDoctoPergunta && (
            <Link href={item.urlDoctoPergunta} target='_blank'>
              <Text variant="caption" style={{ color: '#3265dc' }}>
                Clique aqui para acessar o anexo
              </Text>
            </Link>
          )}
        </Column>
        <Column>
          <Chip label={item.situacao.descricaoSituacao} style={corSituacao[item.situacao.codigoSituacao]} />
          <DateText variant="caption">
            {
              item.dataLiberacaoPerguntaInicio &&
              format(new Date(item.dataLiberacaoPerguntaInicio), "'De ' dd ' de ' MMM ", { locale: PtBr }) +
              format(new Date(item.dataLiberacaoPerguntaFim), "'até ' dd ' de ' MMM ", { locale: PtBr })
            }
          </DateText>
        </Column>
      </Row>
    </AccordionSummary>
    <AccordionDetails>
      {children}
    </AccordionDetails>
  </StyledAccordion>
);
